// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';

import { parseUrl } from '../../utils/urlUtils';
import type { Office } from '../../types/OfficesType';

type Props = {
  location: Location,
  history: History,
  office: Office,
  children: Node,
}


class BuildingSelector extends React.Component<Props> {
  params = () => parseUrl(this.props.location.search);

  updateBuildingParam = (buildingId: string) => {
    this.props.history.push(`${this.props.location.pathname}?office=${this.params().office}${buildingId ? `&buildingId=${buildingId}` : ''}`);
  };

  render() {
    return (
      <div className="office mall-datas">
        <div className="title title-menu">
          <>
            <button
              onClick={() => this.updateBuildingParam(null)}
              className={`building-button${!this.params().buildingId ? ' selected' : ''}`}
            >
              Global
              <div className="underline" />
            </button>

            {
              this.props.office.buildingList
              && this.props.office.buildingList.map(building =>
                (
                  <button
                    key={building.buildingId}
                    onClick={() => this.updateBuildingParam(building.buildingId)}
                    className={`building-button${this.params().buildingId === building.buildingId ? ' selected' : ''}`}
                  >
                    {building.title}
                    <div className="underline" />
                  </button>
                ))
            }
          </>
        </div>
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(BuildingSelector);

